import { fetchAppsStatus as fetchApps, setAuthToken } from 'actions';
import { getClientCredential, getAppsStatus } from 'TamtamAPI';

export const fetchAppsStatus = (isLogged) => {
  return (dispatch, getState) => {
    
    if (!isLogged) {
      const { stoken } = getState().auth;
      return dispatch(fetchApps(getAppsStatus(stoken)));
    }
    
    const { token } = getState().auth;
    if (token == '') {
      return getClientCredential().done((resp) => {
        const clientToken = resp.token.access_token;
        dispatch(setAuthToken(clientToken));
        return dispatch(fetchApps(getAppsStatus(clientToken)));
      });
    }
    return dispatch(fetchApps(getAppsStatus(token)));
  };
};



// WEBPACK FOOTER //
// ./app/actions/thunks/apps.js